export default {
  isMockData: true,
  baseURL: '',
  timeout: 1000
}



// WEBPACK FOOTER //
// ./src/utils/config.js